if (!customElements.get('pcard-sizes')) {
  class PcardSizes extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.product-card__sizes-list');
      this.moreEl = this.querySelector('.product-card__sizes-more');
      if (!this.list || !this.moreEl) return;
      
      this.items = Array.from(this.list.querySelectorAll('.product-card__size'));

      if (this.items.length === 0) return;

      this.measureItemWidth();
      this.truncate();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.truncate());
        this.resizeObserver.observe(this.list);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    measureItemWidth() {
      // Element is display:none at this point, so force it visible off-screen to get real dimensions
      const prevStyle = this.style.cssText;
      this.style.cssText = 'display:block!important;visibility:hidden;position:absolute;pointer-events:none;';

      // Switch list to flex so items size to their natural content width
      const prevListDisplay = this.list.style.display;
      this.list.style.display = 'flex';

      const maxWidth = this.items.reduce((max, item) => Math.max(max, item.offsetWidth), 0);

      this.list.style.display = prevListDisplay;
      this.style.cssText = prevStyle;

      if (maxWidth > 0) {
        this.list.style.setProperty('--size-item-min-width', maxWidth + 'px');
      }
    }

    truncate() {
      // Reset all items to visible
      this.items.forEach((item) => {
        item.style.display = '';
        item.classList.remove('hidden');
      });
      this.moreEl.classList.remove('is-visible');
      this.list.classList.remove('is-truncated');

      if (this.items.length === 0) return;

      const gap = parseFloat(getComputedStyle(this.list).gap) || 4;
      const firstTop = this.items[0].offsetTop;
      const itemHeight = this.items[0].offsetHeight;
      const maxBottom = firstTop + itemHeight * 2 + gap;

      let hiddenCount = 0;
      let lastVisibleIndex = this.items.length - 1;

      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].offsetTop + this.items[i].offsetHeight > maxBottom) {
          hiddenCount = this.items.length - i;
          lastVisibleIndex = i - 1;
          break;
        }
      }

      if (hiddenCount > 0) {
        // Hide overflowing items
        for (let i = lastVisibleIndex + 1; i < this.items.length; i++) {
          this.items[i].classList.add('hidden');
          this.items[i].style.display = 'none';
        }

        // Show "+N" indicator
        this.moreEl.querySelector('.amount').textContent = hiddenCount;
        this.moreEl.classList.add('is-visible');

        // Check if the "+N" itself causes overflow — if so, hide one more item
        if (this.moreEl.offsetTop + this.moreEl.offsetHeight > maxBottom && lastVisibleIndex >= 0) {
          this.items[lastVisibleIndex].classList.add('hidden');
          this.items[lastVisibleIndex].style.display = 'none';
          hiddenCount++;
          this.moreEl.querySelector('.amount').textContent = hiddenCount;
        }

        // Set max-height to prevent any layout shifts
        this.list.style.setProperty('--sizes-max-height', maxBottom - firstTop + 'px');
        this.list.classList.add('is-truncated');
      }
    }
  }

  customElements.define('pcard-sizes', PcardSizes);
}
